import React from 'react'

import { IContestEntry } from 'protos'

import T from 'components/FormattedMessage'
import EventPrize from 'components/EventPrize'

import Label from './Label'

interface Props {
  prize: IContestEntry['prize']
}

const PrizeLabel: React.SFC<Props> = ({ prize }) => (
  <Label
    label={<T id="contests_currentprize" />}
    value={<EventPrize prizes={prize || []} />}
  />
)

export default PrizeLabel
